<template>
  <div class="MR_roadMonitor" ref="MR_roadMonitor">
    <div class="roadMonitor_bar">
      <div
        @click="watchVideo(item)"
        class="videoBar"
        v-for="(item, n) in videoList"
        v-bind:key="n"
      >
        <img
          v-if="(item.cameraType === 'newEasyNvr' || isEasyCvr) && item.picUrl"
          :src="item.picUrl"
          class="videoPic"
          onerror="src='/static/img/no_img.png'"
        />
        <img
          v-else-if="item.nvrIp && item.channelId"
          :src="'/himg/' + item.nvrIp + '/' + item.channelId + '.jpg'"
          class="videoPic"
          onerror="src='/static/img/no_img.png'"
        />
        <!-- <img class="videoPic noImage" /> -->
        <!-- <img src="/static/img/no_img.png"> -->
        <p class="videoIcon">{{ item.classifyName + "-" + item.cameraName }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import cameraList from "./videoList.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      pageInfo: 'MR_roadMonitor.vue',
      computedName: '道路视频监控组件',
      customerId: this.$store.state.customerId,
      timer2: null,
      videoList: [],
      channelsObj: "",
      channelsIds: "",
      videoBaseUrl: bmeConfig.easyNvrUrl,
      isEasyCvr: bmeConfig.isEasyCvr,
      refreshTimer: null,
    };
  },
  inject: ["updateNvrInfo"],
  //计算属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.MR_roadMonitor).outerWidth();
    let h = $(that.$refs.MR_roadMonitor).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    //this.getListData();

    if (bmeConfig.isEasyCvr) {
      this.getEasyCvrList(() => {
        this.getListData();
      });
      if (this.refreshTimer) {
        clearInterval(refreshTimer);
      }
      this.refreshTimer = setInterval(() => {
        this.getEasyCvrList(() => {
          this.getListData();
        });
      }, 5 * 60000);
    } else {
      this.getEasyNvrList(() => {
        this.getListData();
      });
    }
  },
  unmounted() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  },
  //方法集合
  methods: {
    async getListData() {
      /*try {
        const getRoadCameraList = CONFIG.requestName + this.$apiOpt.roadCameraList;
        let res = await this.$apiUtils.get(getRoadCameraList, {
          customerId: this.customerId,
        });
        // console.log(res);
        res.forEach((element) => {
          let classifyName = element.classifyName;
          let list = element.list;
          list.forEach((item) => {
            item.classifyName = classifyName;
            if (
              item.cameraType === "newEasyNvr" ||
              this.customerId == 43 ||
              bmeConfig.isEasyCvr
            ) {
              item["picUrl"] = this.channelsObj
                ? this.channelsObj[item.ipAddress]
                  ? this.videoBaseUrl + this.channelsObj[item.ipAddress]
                  : this.videoBaseUrl +
                    this.channelsObj[item.nvrIp + "_" + item.channelId]
                : "";
              item["recordeId"] = this.channelsIds[item.nvrIp + "_" + item.channelId];
            }
            this.videoList.push(item);
          });
        });

        // console.log(this.videoList);
      } catch (err) {
        console.log(err);
      }*/
      this.videoList = [];
      cameraList.forEach((element) => {
        let classifyName = element.classifyName;
        let list = element.list;
        list.forEach((item) => {
          item.classifyName = classifyName;
          if (
            item.cameraType === "newEasyNvr" ||
            this.customerId == 43 ||
            bmeConfig.isEasyCvr
          ) {
            item["picUrl"] = this.channelsObj
              ? this.channelsObj[item.ipAddress]
                ? this.videoBaseUrl + this.channelsObj[item.ipAddress]
                : this.videoBaseUrl + this.channelsObj[item.nvrIp + "_" + item.channelId]
              : "";
            item["recordeId"] = this.channelsIds[item.nvrIp + "_" + item.channelId];
          }
          this.videoList.push(item);
        });
      });
    },
    async getEasyCvrList(cb) {
      let that = this;
      axios
        .get(
          "/api/v1/login?username=easycvr&password=5cdecdb8e87a0db1fe6e35555a870ae5",
          {}
        )
        .then((res) => {
          let ts = new Date().getTime();
          let token = res.data.EasyDarwin.Body.Token;
          window.easyAxiosToken = token;
          let getUrl = bmeConfig.cvrNewApi
            ? "/api/v1/devicesconfig?start=0&limit=9999"
            : "/api/v1/devices?start=0&limit=9999";
          axios
            .get(getUrl, {
              params: { token: window.easyAxiosToken },
            })
            .then((res) => {
              if (res.data.EasyDarwin.Header.ErrorNum == 200) {
                that.channelsObj = {};
                that.channelsIds = {};
                let devices = res.data.EasyDarwin.Body.Devices;
                devices.forEach((item) => {
                  let tmpDeviceIp = item.DeviceIp ? item.DeviceIp : item.DeviceName;
                  let tmpChannels = item.channels;
                  tmpChannels.forEach((item_) => {
                    let tmpChannelID = item_.Name;
                    that.channelsObj[tmpDeviceIp + "_" + tmpChannelID] = item_.SnapUrl;
                    that.channelsIds[tmpDeviceIp + "_" + tmpChannelID] = item_.ChannelID;
                  });
                });

                // console.log(that.channelsObj, cb);
                if (cb) {
                  cb();
                }
              }
            })
            .catch((err) => {
              console.log(err);
              if (cb) {
                cb();
              }
            });
        })
        .catch((err) => {
          console.log(err);
          if (cb) {
            cb();
          }
        });
    },
    async getEasyNvrList(cb) {
      let that = this;
      axios
        .get(
          "/api/v1/login?username=easynvr&password=ec6206d95f5772323792621ad25ffedf",
          {}
        )
        .then((res) => {
          let that = this;
          let token = res.data.EasyDarwin.Body.Token;
          window.easyAxiosToken = token;
          let ts = new Date().getTime();
          let getUrl = "/api/v1/getchannels?_=" + ts;
          axios
            .get(getUrl, {
              params: { token: window.easyAxiosToken },
            })
            .then((res) => {
              if (res.data.EasyDarwin.Header.ErrorNum == 200) {
                let channels = res.data.EasyDarwin.Body.Channels;
                that.channelsObj = {};
                channels.forEach((item) => {
                  that.channelsObj[item.Name] = item.SnapURL;
                });
                /*this.videoData.forEach((x1, i1) => {
                  x1.list.forEach((x2, i2) => {
                    x2["picUrl"] =
                      "http://localhost:10800" +
                      channelsObj[x2.nvrIp + "_" + x2.channelId];
                  });
                });*/
                //that.getList(channelsObj);
                if (cb) {
                  cb();
                }
              }
            })
            .catch((err) => {
              console.log(err);
              if (cb) {
                cb();
              }
            });
        })
        .catch((err) => {
          console.log(err);
          if (cb) {
            cb();
          }
        });
    },
    watchVideo(item) {
      let that = this;
      //debugger;
      this.$store.commit("changeVideoPlayerSwitch", "open");
      this.updateNvrInfo(item);
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
.MR_roadMonitor {
  width: 600px;
  height: 520px;
  padding-top: 66px !important;
  :deep(.roadMonitor_bar) {
    pointer-events: all;
    &::-webkit-scrollbar-thumb {
      background: transparent !important;
    }
  }
}
.roadMonitor_bar {
  position: absolute;
  top: 60px;
  bottom: 10px;
  overflow: auto;
  left: 15px;
  right: 10px;
}
.videoBar {
  position: relative;
  float: left;
  width: 260px;
  height: 160px;
  margin: 10px 10px;
}
.videoPic {
  position: relative;
  float: left;
  width: 260px;
  height: 160px;
}
.videoIcon {
  position: absolute;
  left: 10px;
  bottom: 10px;
}
</style>
